import { PrimitiveAtom, atom } from 'jotai';
import type { IDataLayer } from '@icecreamsocial/jssdk/src/shared/types/DataLayer';

export const engagementAtom = atom<IDataLayer['engagement'] | undefined>(undefined) as PrimitiveAtom<
  IDataLayer['engagement'] | undefined
>;
